import React from 'react';
import { BadgeCheckIcon, BriefcaseIcon, CalendarDaysIcon, GraduationCapIcon, HomeIcon, LayoutDashboardIcon, MessageSquareIcon, ShieldAlertIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';
import { OperatorShell } from './OperatorShell';
import { institutionSummary } from '../../data/institution';

/**
 * Every section now has an address, so the sidebar links to them rather than
 * listing them as inert text. Note the two safety entries are deliberately
 * different jobs: the desk answers live alerts, the trends view is aggregate
 * reporting.
 */
const GROUPS = [{
  label: 'Overview',
  items: [{
    to: '/institution',
    label: 'Today',
    icon: LayoutDashboardIcon,
    end: true
  }, {
    to: '/institution/overview',
    label: 'Campus overview',
    icon: GraduationCapIcon
  }]
}, {
  label: 'Reporting',
  items: [{
    to: '/institution/students',
    label: 'Student population',
    icon: UsersIcon
  }, {
    to: '/institution/services',
    label: 'Services',
    icon: CalendarDaysIcon
  }, {
    to: '/institution/feedback',
    label: 'Feedback',
    icon: MessageSquareIcon
  }, {
    to: '/institution/accommodation',
    label: 'Accommodation',
    icon: HomeIcon
  }, {
    to: '/institution/career',
    label: 'Career outcomes',
    icon: BriefcaseIcon
  }]
}, {
  label: 'Academic identity',
  items: [{
    to: '/institution/verification',
    label: 'Student verification',
    icon: BadgeCheckIcon
  }]
}, {
  label: 'Campus safety',
  items: [{
    to: '/institution/safety',
    label: 'Safety desk',
    icon: ShieldAlertIcon
  }, {
    to: '/institution/safety-trends',
    label: 'Safety trends',
    icon: ShieldCheckIcon
  }]
}];
export function InstitutionShell() {
  return <OperatorShell consoleKey="institution" consoleName="Institution console" scopeLine={`${institutionSummary.name} · ${institutionSummary.campus}`} groups={GROUPS} summary={<div data-id="element-4547" data-mp="1ubetw2z1hfch">
          <p className="text-caption font-semibold uppercase tracking-wide text-ink-subtle" data-id="element-4548" data-mp="1ubybfiks21pz">
            Integration level
          </p>
          <p className="mt-1 text-caption leading-5 text-ink-muted" data-id="element-4549" data-mp="35a5epdhflpc">
            {institutionSummary.integrationLevel}
          </p>
          <p className="mt-3 border-t border-line pt-3 text-caption leading-5 text-ink-muted" data-id="element-4550" data-mp="843nkv3ps0vu">
            Everything here is aggregated. This console never opens an individual student's
            academic records, messages, notes, wellbeing entries or balances.
          </p>
        </div>} data-id="element-4546" data-mp="3op65h80xi9ak" />;
}